import React, {
  useEffect,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import {
  makeStyles,
  Icon,
  Typography,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Paper,
  Tooltip,
} from '@material-ui/core';
import {
  Skeleton,
  Pagination,
} from '@material-ui/lab';
import { searchAssignedEventsForUser } from '@pingum/app-state-management/userEvents/actions';
import DisplayMessage from '../../../../widgets/DisplayMessage';
import EventStatus from '../../../../widgets/EventStatus';
import {
  getColorForItem,
  getIconForItem,
} from '../../../../../utils/iconHelper';
import { primary } from '../../../../../utils/brand-colors';
import { formatDate } from '../../../../../utils/dateHelper';

import styles from './styles';

const useStyles = makeStyles(styles);

export const MyAssignmentsCardComponent = ({
  onEventClick,
  statuses,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  // local state
  const [page, setPage] = useState(0);

  // redux state
  const { user_id: auth0UserId } = useSelector((state) => state.user.user);
  const {
    userAssignedPageable,
    isFetchingAssigned,
  } = useSelector((state) => state.userEvents);

  useEffect(() => {
    // load assignment data
    dispatch(searchAssignedEventsForUser(auth0UserId, false, false, page, 5));
  }, [page]);

  return (
    <>
      <Typography variant="h5" className={classes.title}>My Assignments</Typography>
      {
        userAssignedPageable.content.length === 0
          ? (
            <div>
              <DisplayMessage
                title="Hurrah!"
                subTitle="You currently have no work assigned to you."
                icon="check_circle"
                iconColor={primary.main}
              />
            </div>
          )
          : (
            <Paper classes={{ root: classes.paperRoot }}>
              <Table>
                <TableBody>
                  {
                    isFetchingAssigned
                      ? [1, 2, 3].map((item) => (
                        <TableRow key={`loading-item-assignments-${item}`}>
                          <TableCell><Skeleton height={50} width={150} /></TableCell>
                          <TableCell><Grid container><Grid item><Skeleton variant="circle" height={40} width={40} /></Grid><Grid item><Skeleton width={75} /><Skeleton width={75} /></Grid></Grid></TableCell>
                        </TableRow>
                      ))
                      : userAssignedPageable.content.map((assignedEvent) => (
                        <TableRow className={classes.row} key={`event-${assignedEvent.id}`} style={{ borderLeft: `4px solid ${getColorForItem(statuses, assignedEvent.currentEventStatus.status.id)}` }} onClick={() => onEventClick(assignedEvent.id)}>
                          <TableCell className={classes.eventNameTableCell}>
                            <div className={classes.eventNameContainer}>
                              <span className={classes.eventName}>{assignedEvent.name}</span>
                              {
                                (assignedEvent.dueDate !== null && new Date(assignedEvent.dueDate).getTime() < new Date().getTime()) && (
                                  <Tooltip title={`This event is past due: ${formatDate(assignedEvent.dueDate)}`}>
                                    <Icon fontSize="inherit" className={classes.dueDateIcon}>notification_important</Icon>
                                  </Tooltip>
                                )
                              }
                            </div>
                            <Typography variant="caption" component="div" className={classes.eventIdField}>#{assignedEvent.id}</Typography>
                          </TableCell>
                          <TableCell className={classes.statusCell}>
                            <EventStatus
                              eventStatus={assignedEvent.currentEventStatus}
                              color={getColorForItem(statuses, assignedEvent.currentEventStatus.status.id)}
                              icon={getIconForItem(statuses, assignedEvent.currentEventStatus.status.id)}
                              hideComment
                              hideDate
                              archived={assignedEvent.archived}
                              completed={!!assignedEvent.completeDate}
                              showDuration={!assignedEvent.completeDate}
                            />
                          </TableCell>
                        </TableRow>
                      ))
                    }
                </TableBody>
              </Table>
            </Paper>
          )
      }
      <Pagination page={page + 1} onChange={(e, value) => { setPage(value - 1); }} count={userAssignedPageable.totalPages} shape="rounded" size="small" classes={{ root: classes.pagination }} />
    </>
  );
};

MyAssignmentsCardComponent.propTypes = {
  onEventClick: PropTypes.func.isRequired,
  statuses: PropTypes.array.isRequired,
};
MyAssignmentsCardComponent.defaultProps = { };

export default MyAssignmentsCardComponent;
